<pms-remittance-advice [eraResponses]="eraResponses"></pms-remittance-advice>
